import { Record } from 'immutable';

interface MeetingsInterface {
  isFetching: boolean;
  meetingsAndOwnersList?: [];
}

export const initialState: MeetingsInterface = {
  isFetching: false,
  meetingsAndOwnersList: []
};

export class MeetingsState extends Record(initialState) {
}
